import { Modal } from "react-bootstrap";
import useFlow from "../hooks/useFlow";

export default function TermsModal() {
  const { showTermsModal, closeTermsModal, doAcceptTerms } = useFlow();

  return (
    <Modal
      show={showTermsModal}
      onHide={closeTermsModal}
      scrollable={true}
      centered
      size="lg"
    >
      <Modal.Header className="border-0" closeButton />
      <Modal.Body className="p-5" style={{ maxHeight: `500px` }}>
        <p>WAIVER & RELEASE</p>
        <p>
          By agreeing and participating in Company&apos;s Activities, you
          represent and warrant that you are in good physical health and do not
          suffer from any medical condition which would limit your participation
          in the Activities. You further understand that it is your
          responsibility to consult with a physician prior to and regarding your
          participation in any Activities offered by the Company. You also
          understand the risks associated with the Activities and agree to
          follow all instructions so that you may safely participate in the
          Activities. You hereby WAIVE AND RELEASE Company, its owners,
          officers, employees, and instructors from any claim, demand, cause of
          action of any kind resulting from or related to your participation in
          the activities offered. You understand and acknowledge that you are
          fully responsible for any and all risks, injuries, or damages, known
          or unknown, which might occur as a result of your participation. By
          signing below and participating, you agree that you have read the
          above release and waiver of liability, fully understand its content
          and that you are legally competent to sign and voluntarily agree to
          the terms and conditions stated above. PHOTO & VIDEO RELEASE I
          acknowledge and agree that photographs and/or video may be taken of me
          while I am involved in the activities and/or at the Facilities. I
          hereby grant the Company, its legal representatives, successors and
          assigns, the irrevocable and unrestricted right (a) to use my likeness
          in any manner and medium and to publish photographs and/or video
          images of me for editorial, trade, advertising, commercial, and any
          other business purpose including, but not limited to, as evidence in
          litigation and (b) to edit, alter, copy, copyright, exhibit, or
          distribute the same without restriction. I hereby waive the right to
          inspect or approve the finished product containing my likeness and
          waive any right to payment or other compensation arising from the use
          of my likeness. I hereby release the Company, its legal
          representatives, successors and assigns from all claims and liability
          relating to any photos or videos. LIABILITY FOR PERSONAL PROPERTY
          Company shall not be liable to Member or any of Member&apos;s guests
          or invitees for any personal property that is damaged, lost, or stolen
          while on or around the Facility including, but not limited to, a
          vehicle or its contents or any property left in a locker. Member shall
          be liable to Company for any damage to the Facility and any equipment,
          furniture, or fixture located thereon caused by Member or any of
          Member&apos;s guests or invitees. I REPRESENT THAT I HAVE READ AND
          UNDERSTAND THIS AGREEMENT. This Agreement represents the entire
          agreement between the parties regarding Member&apos;s general
          membership. No oral agreements exist. There shall be no changes to
          this Agreement unless mutually agreed upon in writing except by
          Optional Contract Renewal initiated by Member signing below. Any and
          all renewals, extensions, and additional purchases of the services
          provided hereunder shall, unless the parties enter into a new and
          separate agreement for such services, automatically be subject to all
          the terms and conditions set forth herein.
        </p>
      </Modal.Body>
      <Modal.Footer className="modal-footer border-0 justify-content-center">
        <button
          type="button"
          className="btn btn-primary btn-lg"
          data-testid="terms-agree-btn"
          onClick={doAcceptTerms}
          data-bs-dismiss="modal"
        >
          Agree
        </button>
      </Modal.Footer>
    </Modal>
  );
}
